module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "burger",
    class: { 
      close: _vm.isClose
    }
  }, [_c('hr'), _c('hr'), _c('hr')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16934f15"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/Burger.vue
// module id = 625
// module chunks = 0